import { HttpClient } from '@shared/adapters/HttpClient';

export interface OrderStatus {
  id: number;
  code: number;
  description: string;
}

export interface OrderStatusMapped {
  id: number;
  name: string;
}

export interface OrderProduct {
  id: number;
  name: string;
  code: string;
  image_hash: string;
}

export interface OrderLine {
  id: number;
  product_id: number;
  name: string;
  amount: number;
  external_product_id: string;
  external_variant_id: string;
  qty: number;
  product: OrderProduct;
  pack_id?: number | null;
  pack_version_id?: number | null;
}

export interface OrderShop {
  id: number;
  channel_id: number;
  name: string;
  image_hash: string;
}

export interface OrderCustomerAddress {
  address1: string;
  address2: string;
  city: string;
  province: string;
  zip: string;
  country_code: string;
}

export interface OrderCustomer {
  address: OrderCustomerAddress;
  name: string;
  phone: string;
  email: string;
}

export interface OrderShipment {
  courier_id: number;
  tracking_number: string;
  status_mapped_id: number;
  last_shipment_update: string;
  date_tracking_update: string;
  processed_at: string;
  returned_at: string | null;
}

export interface OrderResponse {
  id: number;
  ref: string;
  external_id: string;
  shop_id: number;
  status_id: number;
  country_id?: number;
  status: OrderStatus;
  status_mapped?: OrderStatusMapped;
  payment_method_id: number;
  total: number;
  total_tax: number;
  total_shipping: number;
  total_discount: number;
  currency: string;
  order_created_at: string;
  order_paid_at: string;
  shop: OrderShop;
  lines: OrderLine[];
  customer?: OrderCustomer;
  shipment?: OrderShipment;
  external_payment_method?: string;
  external_financial_status?: string;
  fulfilled?: boolean;
  stock_location_order_id?: number;
  shipment_statuses_count?: number;
  errors?: any[];
}

export class OrdersApiAdapter {
  constructor(private httpClient: HttpClient) { }

  async identifyOrder(barcode: string, courierId: number): Promise<OrderResponse> {
    return await this.httpClient.post<OrderResponse>(
      '/returned-receptions/identify-order',
      { barcode, courier_id: courierId }
    );
  }

  // Mantener el método anterior por si se usa en otros lugares
  async getOrderById(orderId: string): Promise<OrderResponse> {
    return await this.httpClient.get<OrderResponse>(`/orders/${orderId}`);
  }
}
